{
  "valid": "Važeće"
}
